export const USER_REGISTER_LOADING='user/register/loading';
export const USER_REGISTER_SUCCESS='user/register/success';
export const USER_REGISTER_FAILURE='user/register/failure';

export const USER_LOGIN_LOADING='user/login/loading';
export const USER_LOGIN_SUCCESS='user/login/success';
export const USER_LOGIN_FAILURE='user/login/failure';

export const USER_LOGOUT_SUCCESS='user/logout/success';